<template>
    <div>
        <div class="SearchHead">
            <el-button v-throttle size="small" type="primary" icon="el-icon-back" @click="goBack"></el-button>
            <el-input size="medium" placeholder="搜索" v-model="SearchVal" @keyup.enter.native="GetData">
                <i slot="suffix" class="el-input__icon el-icon-search" @click="GetData"></i>
            </el-input>
            <!-- <el-button v-throttle type="text" @click="TypeBlon = true">切换</el-button> -->
        </div>
        <div class="ListHead">
            <nut-infiniteloading
                @loadmore="PageChange" 
                :is-show-mod="true" 
                :is-loading="loading" 
            >
            <nut-cell v-for="item in Data" :key="item.id" :show-icon="true" @click-cell="GoPage(item)">
                <span slot="title">{{item.record_name}}</span>
                <span slot="sub-title">申请人：{{item.user_name}}</span>
                <span slot="desc">查看</span>
            </nut-cell>
            </nut-infiniteloading>
            <div v-if="Data.length==0" class="NoData">当前无数据</div>
        </div>
        <nut-popup v-model="TypeBlon" position="bottom">
            <nut-cell :show-icon="true" @click-cell="ResetData('ZL')">
                <span slot="title">资料评审</span>
                <span slot="desc">选择</span>
            </nut-cell>
            <nut-cell :show-icon="true" @click-cell="ResetData('XC')">
                <span slot="title">现场评审</span>
                <span slot="desc">选择</span>
            </nut-cell>
        </nut-popup>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading:false,
                SearchVal:"",
                Data: [],
                ApiType:"",
                Type:"XC",
                TypeBlon:false,
                Page:1,
                PageSize:10,
            };
        },
        mounted() {
            this.ApiType = sessionStorage.getItem('ThisSysTem');
            this.GetData();
        },
        methods: {
            GetData(){
                this.loading = true;
                var url = this.Type=='ZL'?'/api/expert_portal/online/list':'/api/expert_portal/final/list';
                this.$get(url,{
                    keyword:this.SearchVal,
                    page:this.Page,
                    page_size:this.PageSize,
                    system_code:this.ApiType,
                }).then(res=>{
                    this.loading = false;
                    if(res){
                        if(this.Page==1&&res.data.list.length==0){
                            this.Data = [];
                            this.$toast.text('当前无数据');
                        }
                        if(this.Page==1&&res.data.list.length>0){
                            this.Data = res.data.list;
                        }
                        if(this.Page>1&&res.data.list.length>0){
                            this.Data.push(res.data.list);
                        }
                    }
                })
            },
            ResetData(t){
                this.Type = t;
                this.Page = 1;
                this.Data = [];
                this.GetData();
                this.TypeBlon = false;
            },   
            GoPage(i){
                this.$router.push({path: "/MobileExpert/"+i.id+"/"+this.Type});
            },
            goBack(){
                this.$router.go(-1);
            },
            PageChange(){
                this.Page +=1;
                this.GetData();
            },
        }
    }
</script>

<style scoped>
    .SearchHead{
        margin: 10px;
    }
    .NoData{
        text-align: center;
        padding: 10px 0;
        color: #999;
        font-size: 14px;
    }
</style>